import React from "react";
var __jsx = React.createElement;
import { Dialog, TextField } from '@material-ui/core';
import { useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import useGetBlockData from 'components/common/RichTextEditor/hooks/useGetBlockData';
import { GradientButton } from 'components/common/material-ui/custom-components';
import { ButtonContainer, CloseButton, Description, FieldContainer, Title } from './Embed.style';

var Embed = function Embed(_ref) {
  var editorState = _ref.editorState,
      blockKey = _ref.blockKey,
      entityKey = _ref.entityKey,
      removeBlock = _ref.removeBlock,
      updateBlockData = _ref.updateBlockData,
      updateEntity = _ref.updateEntity;

  var _useState = useState(''),
      embedData = _useState[0],
      setEmbedData = _useState[1];

  var _useState2 = useState(false),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useGetBlockData = useGetBlockData(editorState, blockKey, entityKey),
      blockData = _useGetBlockData.blockData,
      entityData = _useGetBlockData.entityData;

  useEffect(function () {
    setIsOpen(blockData.openModal);
    setEmbedData(entityData.embedData);
  }, [blockData, entityData]);
  var handleModalClose = useCallback(function () {
    if (embedData === undefined) {
      removeBlock(blockKey);
      return;
    }

    updateBlockData(blockKey, {
      openModal: false
    });
  }, [embedData, updateBlockData, blockKey, removeBlock]);
  var handleConfirm = useCallback(function () {
    updateEntity(entityKey, {
      embedData: embedData
    });
    updateBlockData(blockKey, {
      openModal: false
    });
  }, [blockKey, embedData, entityKey, updateBlockData, updateEntity]);
  var handleEmbedDataChange = useCallback(function (event) {
    setEmbedData(event.target.value);
  }, []);
  return __jsx(Dialog, {
    open: isOpen,
    onClose: handleModalClose,
    maxWidth: "xl"
  }, __jsx(CloseButton, {
    onClick: handleModalClose
  }), __jsx(FormattedMessage, {
    id: "embed-modal.title",
    tagName: Title
  }), __jsx(FormattedMessage, {
    id: "embed-modal.description",
    tagName: Description
  }), __jsx(FieldContainer, null, __jsx(TextField, {
    variant: "outlined",
    label: __jsx(FormattedMessage, {
      id: "embed-modal.embedIdField"
    }),
    type: "text",
    fullWidth: true,
    value: embedData,
    onChange: handleEmbedDataChange,
    multiline: true,
    rows: 4,
    rowsMax: 16
  })), __jsx(ButtonContainer, null, __jsx(GradientButton, {
    disabled: !embedData,
    onClick: handleConfirm
  }, __jsx(FormattedMessage, {
    id: "embed-modal.confirm"
  }))));
};

export default Embed;